module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/449.98bb368b.png";